import { setDisplayName, wrapDisplayName } from 'recompose';

// eslint-disable-next-line max-len
const setWrappedDisplayName = (name) => (WrappedComponent) =>
	setDisplayName(wrapDisplayName(WrappedComponent, name))(WrappedComponent);

export const overwriteDisplayName = (name) => (WrappedComponent) =>
	setDisplayName(name)(WrappedComponent);

export default setWrappedDisplayName;
